import React, { Component } from "react";
import PropTypes from 'prop-types';

import './style.scss';

class Base extends Component {
	onChange( value ) {
		const { id, updateOption } = this.props;

		updateOption( id, value );
	}
	input() {
		return(
			<div />
		);
	}
	render() {
		const { id, title, desc } = this.props;
		return(
			<div className="ok-input-wrap">
				<div className="ok-input-info">
					<label htmlFor={ id }>{ title }</label>
					<p>{desc}</p>
				</div>
				<div className="ok-input">
					{ this.input() }
				</div>
			</div>
		);
	}
}

Base.propTypes = {
	id: PropTypes.string,
	title: PropTypes.string,
	desc: PropTypes.string,
	updateOption: PropTypes.func,
};

export default Base;
